import { type ResourcesConfig } from 'aws-amplify';

function must(val: string | undefined): string {
    if (val === undefined) {
        throw new Error(`undefined environment variable`);
    }

    return val;
}

const amplifyconfiguration: ResourcesConfig = {
    Auth: {
        Cognito: {
            userPoolId: must(import.meta.env.VITE_AWS_USER_POOL_ID),
            userPoolClientId: must(import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID),
            identityPoolId: must(import.meta.env.VITE_AWS_IDENTITY_POOL_ID),
            loginWith: {
                oauth: {
                    domain: must(import.meta.env.VITE_COGNITO_DOMAIN),
                    scopes: ['openid', 'profile', 'email', 'aws.cognito.signin.user.admin'],
                    redirectSignIn: [must(import.meta.env.VITE_DOMAIN)],
                    redirectSignOut: [must(import.meta.env.VITE_DOMAIN) + '/login'],
                    responseType: 'code',
                },
            },
        },
    },
    API: {
        GraphQL: {
            endpoint: must(import.meta.env.VITE_GRAPHQL_API_URL),
            region: must(import.meta.env.VITE_AWS_REGION),
            defaultAuthMode: 'lambda',
        },
    },
};

export default amplifyconfiguration;